<template>
  <div v-if="isRentOut" class="py-5">
    <v-divider class="mt-5 mb-10" />

    <h2>
      {{$t('rentOut.status')}}
    </h2>

    <!-- status message -->
    <div v-if="serviceReport.finish_status === 'NOTHING_TO_EXECUTE_KEYS_DELIVERED'">
      <v-row>
        <v-col class="mb-n3" cols="12" sm="6" md="4">
          <v-alert class="mb-0" color="success" dense text>
            <div class="d-flex">
              <v-icon color="success" left small>
                mdi-check-circle
              </v-icon>
              <p class="body-2 mb-0">
                {{$t('rentOut.noComplianceFound')}}
              </p>
            </div>
          </v-alert>
        </v-col>
        <v-col class="mb-n3" cols="12" sm="6" md="4">
          <v-alert class="mb-0" color="success" dense text>
            <div class="d-flex">
              <v-icon color="success" left small>
                mdi-key-chain-variant
              </v-icon>
              <p class="body-2 mb-0">
                {{$t('rentOut.keyWithHost')}}
              </p>
            </div>
          </v-alert>
        </v-col>
        <v-col class="mb-n3" cols="12" sm="6" md="4">
          <v-alert class="mb-0" color="success" dense text>
            <div class="d-flex">
              <v-icon color="success" left small>
                mdi-note-check
              </v-icon>
              <p class="body-2 mb-0">
                {{$t('rentOut.termWasSent')}}
              </p>
            </div>
          </v-alert>
        </v-col>
      </v-row>
    </div>
    <!-- /status message -->

    <!-- status message -->
    <div v-if="serviceReport.finish_status === 'SERVICE_PAID_KEYS_DELIVERED'">
      <v-row>
        <v-col class="mb-n3" cols="12" sm="6" md="4">
          <v-alert class="mb-0" color="success" dense text>
            <div class="d-flex">
              <v-icon color="success" left small>
                mdi-check-circle
              </v-icon>
              <p class="body-2 mb-0">
                {{$t('rentOut.complianceAccepted')}}
              </p>
            </div>
          </v-alert>
        </v-col>
        <v-col class="mb-n3" cols="12" sm="6" md="4">
          <v-alert class="mb-0" color="success" dense text>
            <div class="d-flex">
              <v-icon color="success" left small>
                mdi-key-chain-variant
              </v-icon>
              <p class="body-2 mb-0">
                {{$t('rentOut.keyWithHost')}}
              </p>
            </div>
          </v-alert>
        </v-col>
        <v-col class="mb-n3" cols="12" sm="6" md="4">
          <v-alert class="mb-0" color="success" dense text>
            <div class="d-flex">
              <v-icon color="success" left small>
                mdi-note-check
              </v-icon>
              <p class="body-2 mb-0">
                {{$t('rentOut.termWasSent')}}
              </p>
            </div>
          </v-alert>
        </v-col>
      </v-row>
    </div>
    <!-- /status message -->

    <!-- status message -->
    <div v-if="serviceReport.finish_status === 'SERVICE_NOT_PAID_KEYS_NOT_DELIVERED'">
      <v-row>
        <v-col class="mb-n3" cols="12" sm="6" md="4">
          <v-alert class="mb-0" color="warning" dense text>
            <div class="d-flex">
              <v-icon color="warning" left small>
                mdi-currency-usd-off
              </v-icon>
              <p class="body-2 mb-0">
                {{$t('rentOut.complianceNotAccepted')}}
              </p>
            </div>
          </v-alert>
        </v-col>
        <v-col class="mb-n3" cols="12" sm="6" md="4">
          <v-alert class="mb-0" color="warning" dense text>
            <div class="d-flex">
              <v-icon color="warning" left small>
                mdi-key-chain-variant
              </v-icon>
              <p class="body-2 mb-0">
                {{$t('rentOut.keyWithTenant')}}
              </p>
            </div>
          </v-alert>
        </v-col>
        <v-col class="mb-n3" cols="12" sm="6" md="4">
          <v-alert class="mb-0" color="warning" dense text>
            <div class="d-flex">
              <v-icon color="warning" left small>
                mdi-note-remove
              </v-icon>
              <p class="body-2 mb-0">
                {{$t('rentOut.termNotSent')}}
              </p>
            </div>
          </v-alert>
        </v-col>
      </v-row>
    </div>
    <!-- /status message -->

    <!-- status message -->
    <div v-if="serviceReport.finish_status === 'SERVICE_NOT_PAID_KEYS_DELIVERED'">
      <v-row>
        <v-col class="mb-n3" cols="12" sm="6" md="4">
          <v-alert class="mb-0" color="warning" dense text>
            <div class="d-flex">
              <v-icon color="warning" left small>
                mdi-currency-usd-off
              </v-icon>
              <p class="body-2 mb-0">
                {{$t('rentOut.tenantDidNotWantToPayOnTime')}}
              </p>
            </div>
          </v-alert>
        </v-col>
        <v-col class="mb-n3" cols="12" sm="6" md="4">
          <v-alert class="mb-0" color="success" dense text>
            <div class="d-flex">
              <v-icon color="success" left small>
                mdi-key-chain-variant
              </v-icon>
              <p class="body-2 mb-0">
                {{$t('rentOut.keyWithHost')}}
              </p>
            </div>
          </v-alert>
        </v-col>
        <v-col class="mb-n3" cols="12" sm="6" md="4">
          <v-alert class="mb-0" color="success" dense text>
            <div class="d-flex">
              <v-icon color="success" left small>
                mdi-note-check
              </v-icon>
              <p class="body-2 mb-0">
                {{$t('rentOut.termWasSent')}}
              </p>
            </div>
          </v-alert>
        </v-col>
      </v-row>
    </div>
    <!-- /status message -->

    <!-- status message -->
    <div v-if="serviceReport.finish_status === 'CONFLICT_SERVICE_NOT_PAID_KEYS_DELIVERED'">
      <v-row>
        <v-col class="mb-n3" cols="12" sm="6" md="4">
          <v-alert class="mb-0" color="warning" dense text>
            <div class="d-flex">
              <v-icon color="warning" left small>
                mdi-currency-usd-off
              </v-icon>
              <p class="body-2 mb-0">
                {{$t('rentOut.conflictTenantDidNotAgree')}}
              </p>
            </div>
          </v-alert>
        </v-col>
        <v-col class="mb-n3" cols="12" sm="6" md="4">
          <v-alert class="mb-0" color="success" dense text>
            <div class="d-flex">
              <v-icon color="success" left small>
                mdi-key-chain-variant
              </v-icon>
              <p class="body-2 mb-0">
                {{$t('rentOut.keyWithHost')}}
              </p>
            </div>
          </v-alert>
        </v-col>
        <v-col class="mb-n3" cols="12" sm="6" md="4">
          <v-alert class="mb-0" color="success" dense text>
            <div class="d-flex">
              <v-icon color="success" left small>
                mdi-note-check
              </v-icon>
              <p class="body-2 mb-0">
                {{$t('rentOut.termWasSent')}}
              </p>
            </div>
          </v-alert>
        </v-col>
      </v-row>
    </div>
    <!-- /status message -->

    <div v-if="appointmentTerms.length || appointmentTermsSigned.length">
      <h4 class="mt-6 mb-2">
        {{ $t('appointment.label.terminationTerm') }}
      </h4>
      <AppointmentFilesTermList
        :terms="appointmentTerms"
        :signedTerms="appointmentTermsSigned"
        :showClickSignButton="showClickSignButton"
      />
    </div>
  </div>
</template>

<script>
import AppointmentFilesTermList from '../terms/AppointmentFilesTermList'
import { rentOutTypes } from '@/components/appointment/formFieldsCreate/appointmentFormDefaults'

export default {
  name: 'RentOutMessages',

  components: {
    AppointmentFilesTermList
  },

  props: {
    appointment: {
      type: Object
    },

    appointmentTerms: {
      type: Array,
    },

    appointmentTermsSigned: {
      type: Array,
    },

    serviceReport: {
      type: Object
    },
    showClickSignButton: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isRentOut() {
      return rentOutTypes.includes(this.appointment.type)
    }
  }
}
</script>
